import { AppBase } from './../app.base';
import { NetUtil } from './../framework/utils/NetUtil';
import { LevelInfo } from './../data/LevelInfo';
import { LevelRecord, userRecord } from './../data/UserRecord';
import { IframeObject } from './IframeObject';
import { FW } from './../framework/Framework';

export class GameHost {

    constructor(private level: string) {
    }

    public execute(): Promise<string> {
        return new Promise<string>((resolve, _reject) => {
            FW.root.visible = false;
            FW.setActive(false);
            this.startIframe()
                .then(nextLevel => {
                    FW.root.visible = true;
                    FW.setActive(true);
                    resolve(nextLevel);
                });
        });
    }

    private get iframeSrc(): string {
        let url: string = '/fso5/game.html?level=' + this.level;
        if(AppBase.debug) {
            url += '&debug=' + NetUtil.getQueryStringValue('debug');
        }
        return url;
    }

    private startIframe(): Promise<string> {
        let debug: boolean = location.hostname === 'localhost';
        if (debug) {
            return this.debugExecute();
        }

        var iframeobj: IframeObject = new IframeObject();
        iframeobj.setDimension(0, 0, "100%", "100%");
        return iframeobj.start(this.iframeSrc, recordJson => {
            if(recordJson) {
                userRecord.setLevelRecord(this.level, new LevelRecord(this.level, recordJson));
            }
        });
    }

    private debugExecute(): Promise<string> {
        return new Promise<string>((resolve) => {
            setTimeout(() => {
                let fail: boolean = false;
                if (fail) {
                    resolve(null);
                } else {
                    let record: LevelRecord = new LevelRecord(this.level, {});
                    record.stars = 2;
                    record.time = 3600;
                    userRecord.setLevelRecord(this.level, record);

                    let lv: LevelInfo = LevelInfo.fromString(this.level);
                    resolve(lv.getNeighbor(1).level);
                }
            }, 1000);
        });
    }
}


// WEBPACK FOOTER //
// ./src/worlds/GameHost.ts